import React, { useState } from "react";
import { Button, Form, Input, message } from "antd";
import { useTranslation } from "react-i18next";

export const UpdatePassword = () => {
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [form] = Form.useForm();
  const { t } = useTranslation();

  return (
    <Form
      form={form}
      hideRequiredMark
      labelAlign="left"
      labelCol={{ span: 4 }}
      onFinish={async (values) => {
        try {
          setLoading(true);
          window.__user__ = await window.__authing__.updatePassword(password, values.oldPassword);
          setPassword("");
          form.resetFields();
          message.success(t("common.updateSuccess"));
        } finally {
          setLoading(false);
        }
      }}
    >
      <Form.Item
        name="oldPassword"
        label={t("user.currentPwd")}
        rules={[{ required: true, message: t("login.noEmpty") }]}
      >
        <Input.Password
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={t("user.inputCurrPwd")}
        />
      </Form.Item>

      <Form.Item name="newPassword" label={t("user.newPwd")} rules={[{ required: true, message: t("login.noEmpty") }]}>
        <Input.Password
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={t("user.inputNewPwd")}
        />
      </Form.Item>

      <Form.Item
        name="repeatPassword"
        label={t("user.confrimPwd")}
        rules={[
          { required: true, message: t("login.noEmpty") },
          {
            validator: (_, value, callback) => {
              if (form.getFieldValue("newPassword") !== value) {
                callback(t("user.needSameWithNewPwd"));
              } else {
                callback();
              }
            },
          },
        ]}
      >
        <Input.Password
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder={t("user.inputNewPwd")}
        />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 4 }}>
        <Button loading={loading} type="primary" htmlType="submit">
          {t("user.confirmModify")}
        </Button>
      </Form.Item>
    </Form>
  );
};
